import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 1D7700E7-2963-479F-81E1-910E2566894F
 * name arrow-collapse-vertical
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-collapse-vertical.svg
 * tags
 * - Arrow 
 */
export const ArrowCollapseVerticalIcon = createSvgIcon(<><path d="M4,12H20V14H4V12M4,9H20V11H4V9M16,4L12,8L8,4H11V1H13V4H16M8,19L12,15L16,19H13V22H11V19H8Z" /></>, 'ArrowCollapseVerticalIcon');
export default ArrowCollapseVerticalIcon